export default __webpack_public_path__ + "static/media/phaphrom_img5.0ac25d5e.webp";